export const getCspNonce = (): string | undefined =>
  document.querySelector('meta[name="csp-nonce"]')?.getAttribute("content") ?? undefined;
